(function () {
  'use strict';

  function initEditorialCarousel(sectionId) {
    var section = document.querySelector('[data-section-id="' + sectionId + '"].ed-carousel');
    if (!section) return;

    var viewport = section.querySelector('.ed-carousel__viewport');
    var track = section.querySelector('.ed-carousel__track');
    var cards = section.querySelectorAll('.ed-carousel__card');
    if (!viewport || !track || cards.length === 0) return;

    var autoSlideEnabled = section.dataset.autoSlide === 'true';
    var interval = (parseInt(section.dataset.slideInterval, 10) || 8) * 1000;
    var visibleDesktop = parseInt(section.dataset.visibleDesktop, 10) || 2;
    var visibleMobile = parseInt(section.dataset.visibleMobile, 10) || visibleDesktop;
    var autoSlideTimer = null;
    var currentIndex = 0;
    var MOBILE_BP = 767;
    var mqMobile = window.matchMedia('(max-width: ' + MOBILE_BP + 'px)');

    visibleDesktop = Math.max(1, Math.min(2, visibleDesktop));
    visibleMobile = Math.max(1, Math.min(2, visibleMobile));

    if (cards.length <= Math.min(visibleDesktop, visibleMobile)) return;

    function getVisible() {
      return mqMobile.matches ? visibleMobile : visibleDesktop;
    }

    function getStepWidth() {
      var card = cards[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    function maxIndex() {
      return Math.max(0, cards.length - getVisible());
    }

    function getMaxOffset() {
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }

    function slideTo(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex()));
      var stepWidth = getStepWidth();
      var targetOffset = Math.min(currentIndex * stepWidth, getMaxOffset());
      track.style.transform = 'translateX(-' + targetOffset + 'px)';
    }

    function slideNext() {
      if (currentIndex >= maxIndex()) {
        currentIndex = 0;
      } else {
        currentIndex = Math.min(currentIndex + getVisible(), maxIndex());
      }
      slideTo(currentIndex);
    }

    function startAutoSlide() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!autoSlideEnabled) return;
      stopAutoSlide();
      autoSlideTimer = setInterval(slideNext, interval);
    }

    function stopAutoSlide() {
      if (autoSlideTimer) {
        clearInterval(autoSlideTimer);
        autoSlideTimer = null;
      }
    }

    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function () {
      if (!isDragging) startAutoSlide();
    });

    startAutoSlide();

    /* ---- Pointer drag (mouse + touch + pen) ---- */

    var isDragging = false;
    var dragStartX = 0;
    var dragStartTranslate = 0;
    var dragDelta = 0;
    var dragMoved = false;
    var activePointerId = null;

    function getCurrentTranslate() {
      var transform = track.style.transform;
      if (!transform || transform === 'none') return 0;
      var match = transform.match(/translateX\((-?[\d.]+)px\)/);
      return match ? parseFloat(match[1]) : 0;
    }

    function onDragStart(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartTranslate = getCurrentTranslate();
      dragDelta = 0;
      activePointerId = e.pointerId;
      track.classList.add('is-dragging');
      stopAutoSlide();
      if (typeof viewport.setPointerCapture === 'function') {
        try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
    }

    function onDragMove(e) {
      if (!isDragging) return;
      if (activePointerId !== null && e.pointerId !== activePointerId) return;
      dragDelta = e.clientX - dragStartX;
      if (Math.abs(dragDelta) > 5) dragMoved = true;
      var newTranslate = dragStartTranslate + dragDelta;
      var maxTranslate = -getMaxOffset();
      newTranslate = Math.max(maxTranslate, Math.min(0, newTranslate));
      track.style.transform = 'translateX(' + newTranslate + 'px)';
    }

    function onDragEnd(e) {
      if (!isDragging) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;
      isDragging = false;
      activePointerId = null;
      track.classList.remove('is-dragging');
      var stepWidth = getStepWidth();
      var finalTranslate = dragStartTranslate + dragDelta;
      var snappedIndex = Math.round(-finalTranslate / stepWidth);
      slideTo(snappedIndex);
      startAutoSlide();
    }

    viewport.addEventListener('pointerdown', onDragStart);
    viewport.addEventListener('pointermove', onDragMove);
    viewport.addEventListener('pointerup', onDragEnd);
    viewport.addEventListener('pointercancel', onDragEnd);

    viewport.addEventListener('click', function (e) {
      if (dragMoved) e.preventDefault();
    }, true);

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        slideTo(currentIndex);
      }, 150);
    });

    section._editorialCarouselCleanup = function () {
      stopAutoSlide();
      viewport.removeEventListener('pointerdown', onDragStart);
      viewport.removeEventListener('pointermove', onDragMove);
      viewport.removeEventListener('pointerup', onDragEnd);
      viewport.removeEventListener('pointercancel', onDragEnd);
    };
  }

  function initAll() {
    document.querySelectorAll('.ed-carousel').forEach(function (el) {
      var sectionId = el.dataset.sectionId;
      if (sectionId) initEditorialCarousel(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.ed-carousel');
    if (el) {
      var sectionId = el.dataset.sectionId;
      if (sectionId) initEditorialCarousel(sectionId);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('.ed-carousel');
    if (el && el._editorialCarouselCleanup) el._editorialCarouselCleanup();
  });
})();
